var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9411 2.83818C18.5683 2.18891 18.5683 1.13623 17.9411 0.486955C17.314 -0.162319 16.2972 -0.162319 15.67 0.486955L9.23506 7.14876L2.80014 0.486956C2.17298 -0.162317 1.15615 -0.162318 0.528985 0.486956C-0.0981768 1.13623 -0.0981763 2.18891 0.528985 2.83818L6.96391 9.49999L0.528965 16.1618C-0.0981963 16.8111 -0.098197 17.8638 0.528965 18.513C1.15613 19.1623 2.17296 19.1623 2.80012 18.513L9.23506 11.8512L15.67 18.513C16.2972 19.1623 17.314 19.1623 17.9412 18.513C18.5683 17.8638 18.5683 16.8111 17.9412 16.1618L11.5062 9.49999L17.9411 2.83818Z",
    fill: "#1E1E22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.ce32b9099e4c2c9ca2ad4e4b526fb82f.svg";
export { ForwardRef as ReactComponent };